import play from '../assets/play.svg?raw';
import pause from '../assets/pause.svg?raw';
import volumeUp from '../assets/volume-up.svg?raw';
import volumeDown from '../assets/volume-down.svg?raw';
import volumeOff from '../assets/volume-off.svg?raw';
import orderRandom from '../assets/order-random.svg?raw';
import orderList from '../assets/order-list.svg?raw';
import menu from '../assets/menu.svg?raw';
import loopAll from '../assets/loop-all.svg?raw';
import loopOne from '../assets/loop-one.svg?raw';
import loopNone from '../assets/loop-none.svg?raw';
import loading from '../assets/loading.svg?raw';
import right from '../assets/right.svg?raw';
import skip from '../assets/skip.svg?raw';
import lrc from '../assets/lrc.svg?raw';

const Icons = {
    play: play,
    pause: pause,
    volumeUp: volumeUp,
    volumeDown: volumeDown,
    volumeOff: volumeOff,
    orderRandom: orderRandom,
    orderList: orderList,
    menu: menu,
    loopAll: loopAll,
    loopOne: loopOne,
    loopNone: loopNone,
    loading: loading,
    right: right,
    skip: skip,
    lrc: lrc,
};

export default Icons;
